<template>
  <div class="main-content-container container-fluid px-4">
    <div class="page-header row no-gutters py-4">
      <div class="col-8 col-sm-4 text-center text-sm-left mb-0">
        <span class="text-uppercase page-subtitle">Inventory</span>
        <!-- <h3 class="page-title">upload Syncc data</h3> -->
      </div>
    </div>
    <d-card class="card-small mb-4">
      <!-- Card Header -->
      <d-card-header class="border-bottom">
        <span style="font-size:20px; font-weight:500" class="m-0">Product Update</span>

        <!-- <router-link :to="{ name: 'user-setup'}">
          <button
            class="btn btn-md btn-primary"
            style="margin-left: 900px;background-color:white;margin-top:-40px;color:black;"
          >Dashboard</button>
          style="margin-left: 400px;background-color:white;margin-top:-30px;color:black;" 
        </router-link> -->

        <button
            class="btn btn-md btn-primary"
            style="float:right; background-color:white; color:black;"
          >
          <download-excel :data="ProductMasterUpload.DataModel.UIData.VtexProductTemplate"   name="VtexProduct_Templates"><span style="marige-top:10px;" > Download Template </span>   </download-excel>  </button>


      </d-card-header>

      <d-list-group flush>
        <d-list-group-item class="p-3">
          <d-row>
            <d-col>
              <d-form id="pricing">
                <d-form-row>
                 
               
                  <d-col md="12" class="form-group row">
                    <label class="col-md-3 col-form-label">Product Master file *</label>
                    <div class="col-md-7" v-if="ProductMasterUpload.DataModel.UIData.UploadedDataCount == 0">   
                         <div class="button_group">
                          <a href="javascript:;" class="button_s my_file el-button button_s el-button--primary el-button--small" >
                          
                          <input type="file" id="avatar" @change="importExcel" name="avatar">
                          </a>
                          <!-- :disabled="(ProductMasterUpload.DataModel.UIData.ProductMasterList.length == 0)" -->
                          <d-button type="button" id="submit" title="Please Select the panel"  class="btn-accent" :disabled="(ProductMasterUpload.DataModel.UIData.ProductMasterList.length == 0)" @click="ProductMasterUploadData" style="margin-right:10px" >upload Data</d-button>
                                <d-button type="button" id="submit" class="btn-accent" @click="ClearFileData">Cancel</d-button>
                          </div>
                    </div>
                     <div class="col-md-7" v-if="ProductMasterUpload.DataModel.UIData.UploadedDataCount > 0">  
                         <div class="SuccessLabel">
                           <span class="material-icons"> done_all </span> {{ ProductMasterUpload.DataModel.UIData.LoadedFileName }} file data uploaded Successfully 
                         </div>
                    </div>
                  </d-col>

                 <d-col md="12" class="form-group row" v-if="ProductMasterUpload.DataModel.UIData.UploadStatus">
                    <label class="col-md-3 col-form-label">Total no. Of Recoreds from file</label>
                    <div class="col-md-4">
                      <label class="col-md-5 col-form-label">{{ProductMasterUpload.DataModel.Data.SynccentricScrapList}}</label>
                    </div>
                 </d-col>

                 <d-col md="12" class="form-group row" v-if="ProductMasterUpload.DataModel.UIData.UploadStatus">
                    <label class="col-md-3 col-form-label">Total no. Of Recoreds Rejected</label>
                    <div class="col-md-4">
                      <label class="col-md-5 col-form-label">{{ProductMasterUpload.DataModel.UIData.RejectedList.length}}</label>
                    </div>
                 </d-col>


                <d-col md="12" class="form-group row" v-if="ProductMasterUpload.DataModel.UIData.UploadStatus">
                    <label class="col-md-3 col-form-label">Total no. Of Recoreds Progressed</label>
                    <div class="col-md-4">
                      <label class="col-md-5 col-form-label">{{ProductMasterUpload.DataModel.UIData.Progressed}}</label>
                    </div>
                 </d-col>
                
                <d-col md="12" class="form-group row"  v-if="(ProductMasterUpload.DataModel.UIData.Progressed == ProductMasterUpload.DataModel.UIData.ProductMasterList.length) && ProductMasterUpload.DataModel.UIData.UploadStatus">
                    <label class="col-md-3 col-form-label"></label>
                    <div class="col-md-7">
                    <d-button type="button" class="btn-accent" > 
                    <download-excel :data="ProductMasterUpload.DataModel.UIData.RejectedList"   :name="ProductMasterUpload.DataModel.UIData.RejectedFileName"><span style="marige-top:10px;" > Download Reject List </span> </download-excel>
                    </d-button>
                    </div>

<div class style="text-align:center"  v-if="ProductMasterUpload.DataModel.UIData.UploadStatus">
                  <d-button type="button" id="submit" class="btn-accent" @click="ClearUsersetup">Cancel</d-button>
                </div>         

                  </d-col>

                <!-- <div class style="text-align:center"  v-if="ProductMasterUpload.DataModel.UIData.UploadStatus">
                  <d-button type="button" id="submit" class="btn-accent" @click="ClearUsersetup">Cancel</d-button>
                </div>          -->
 

                </d-form-row>

                <br />

              </d-form>
            </d-col>
          </d-row>
        </d-list-group-item>
      </d-list-group>
    </d-card>
    <div v-if="ProductMasterUpload.PageLoad" class="load-container load1"><div class="loader">Loading...</div></div>
  </div>
</template>
<script>
import Utilities from "@/Utilities/Utilities";
import axios from "axios";
import xlsx from "xlsx";
import XLSX from 'xlsx';
import $ from 'jquery'

export default {
  name: 'ProductMasterUpload',
   data() {
    return {
      ProductMasterUpload: {
        PageType: "Master",
        PageLoad: false, 
        DataModel: {
          Data: {
             QueryString:null,
            ProductMaster:null,
            ProductMasterList:[],
            Token:null,
            Curd:null,
            CreatedBy:0
          },
          UIData: {
            mySteps:['Step 1', 'Step 2', 'Step 3'],
            currentStep:0,
            Template:[],
            minMaxList:[],
            Progressed:0,
            RejectedList:[],
            AvailablityTemplate:[],
            RejectedFileName:null,
            ProductMasterList:[],
            ProductMasterList1:[],
            ProductMasterList2:[],
            ProductMasterList3:[],
            ProductMasterList4:[],
            ProductMasterList5:[],
            ProductMasterList6:[],
            ProductMasterList7:[],
            ProductMasterList8:[],
            ProductMasterList9:[],
            ProductMasterList10:[],
            AvailablityList:[],
            AvailablityTemplateCount:0,
            TemplateIsAvailable :false,
            FileName:"Template",
            LoadedFileName:"",
            AvailabilityFileName:"Template",
            UploadedDataCount:0,
            VtexProductTemplate:[{
              _SkuId:0,
              _SkuName:null,	
              _ActivateSkuIfPossible:"Yes",	
              _SkuIsActive:"Yes",	
              _SkuEan:null,	
              _Height:null,	
              _ActualHeight:null,	
              _Width:null,	
              _ActualWidth:null,	
              _Length:null,	
              _ActualLength:null,	
              _Weight:null,	
              _ActualWeight:null,	
              _MeasurementUnit:null,	
              _UnitMultiplier:null,	
              _SKUReferenceCode:null,	
              _RewardValue:null,	
              _EstimatedDateArrival:null,	
              _ManufacturerCode:null,	
              _ProductId:null,	
              _ProductName:null,	
              _ProductShortDescription:null,	
              YES:null,	
              _ProductReferenceCodeId:null,	
              _ShowOnSite:null,	
              _CaptionLink:null,	
              _ProductDescription:null,	
              _ProductLaunchDate:null,	
              _Keywords:null,	
              _SiteTitle:null,	
              _MetaTagDescription:null,	
              _SupplierId:null,	
              _ShowOutOfStock:null,	
              _Kit:null,	
              _DepartmentId:null,	
              _DepartamentName:null,	
              _CategoryId:null,	
              _CategoryName:null,	
              _BrandId:null,	
              _Brand:null,	
              _CubicWeight:null,	
              _CommercialCondition:null,	
              _Stores:"1,2,3",	
              _Accessories:null,	
              _Similar:null,	
              _Suggestions:null,	
              _MostrarJunto:null,	
              _Attachment:null,	
              MainImage_URL:null,	
              AdditionalImages1_URL:null,	
              AdditionalImages2_URL:null,	
              AdditionalImages3_URL:null,	
              AdditionalImages4_URL:null,
            }]
          },
        },
        SessionInfo: {
          PageInfo: {
            userId: 0,
          },
        },
        ErrorInfo: [
          {
            ErrorID: 1,
            ErrorName: "",
            ErrorMessage: "",
          },
        ],

        Masters: {
          CountryMaster:[],
          PanelList:[
            {
              Name : "Amazon UAEDirect",
              Country:"UAEDirect",
              Panel:"Amazon"
            },
            {
              Name : "Amazon India",
              Country:"India",
              Panel:"Amazon"
            },
            {
              Name : "Amazon IndiaDirect",
              Country:"IndiaDirect",
              Panel:"Amazon"
            },
            {
              Name : "Amazon Australia",
              Country:"Australia",
              Panel:"Amazon"
            },
            {
              Name : "Amazon UAE",
              Country:"UAE",
              Panel:"Amazon"
            },
            {
              Name : "Amazon Mexico",
              Country:"Mexico",
              Panel:"Amazon"
            },
            {
              Name : "Amazon Canada",
              Country:"Canada",
              Panel:"Amazon"
            },
            {
              Name : "Amazon Brazil",
              Country:"Brazil",
              Panel:"Amazon"
            },
            {
              Name : "Amazon Singapore",
              Country:"Singapore",
              Panel:"Amazon"
            },
            {
              Name : "Amazon KSA",
              Country:"KSA",
              Panel:"Amazon"
            },
            {
              Name : "Jokoka",
              Country:"UAE",
               Panel:"Jokoka"
            },
            {
              Name : "StoreUS",
              Country:"UAE",
               Panel:"StoreUS"
            },
            {
              Name : "Noon UAE",
              Country:"UAE",
              Panel:"Noon"
            },
            {
              Name : "Noon KSA",
              Country:"KSA",
              Panel:"Noon"
            }
          ]
        },
      },
    };
  },

  mounted(){
      this.ProductMasterUpload.SessionInfo.PageInfo.userId = sessionStorage.getItem("UserId");
       this.ProductMasterUpload.DataModel.Data.CreatedBy = sessionStorage.getItem("UserId");
      // this.ListAllFromCountry();
  },
  methods: {
ClearFileData(){
     this.ProductMasterUpload.DataModel.Data.FromCountry = null;
     this.ProductMasterUpload.DataModel.UIData.UploadedDataCount = 0;
     this.ClearUsersetup();
     document.getElementById("pricing").reset();
},

panelOnchange(){

            this.ProductMasterUpload.DataModel.UIData.Template=[];
            this.ProductMasterUpload.DataModel.UIData.TemplateIsAvailable = false;
},

ClearUsersetup(){
            this.ProductMasterUpload.DataModel.UIData.Template = [];
            this.ProductMasterUpload.DataModel.UIData.TemplateIsAvailable = false;
            this.ProductMasterUpload.DataModel.Data.SynccentricScrapList = 0;
            this.ProductMasterUpload.DataModel.UIData.UploadStatus = false;
            this.ProductMasterUpload.DataModel.UIData.ProductMasterList=[];
            // this.cleareList();
        this.ProductMasterUpload.DataModel.Data.PanelInfo ={
          Name : null,
              Country:null
        }
        this.ProductMasterUpload.DataModel.Data.FromCountry =null;
        this.ProductMasterUpload.DataModel.UIData.UploadedDataCount= 0;
         document.getElementById("pricing").reset();
      },

getQuery()
{
      let vm = this;
      vm.ProductMasterUpload.PageLoad = true;
      var Token = sessionStorage.getItem("Token");
      this.ProductMasterUpload.DataModel.Data.Token = Token;
      this.ProductMasterUpload.DataModel.Data.CRUD = "AmazonAEMasterUpload";
      var dataString = JSON.stringify(this.ProductMasterUpload.DataModel.Data);

      axios.post("APIScript/PHP/APIService/SynccentricScrap/SynccentricScrap.php",dataString)
        .then(function (response) {
          if (response.data.ErrorInfo == null) {
            vm.ProductMasterUpload.PageLoad = false;
            vm.ProductMasterUpload.DataModel.UIData.UploadedDataCount= response.data.Result;
            vm.UpDateProductMasterUploadsMaster();
          } else {

          }
        })
        .catch(function (response) {
          // console.log(response);
            vm.ProductMasterUpload.PageLoad = false;
          vm.$swal.fire("Oops", "Something went worng", "error");
        });

},



UpDateProductMasterUploadsMaster()
{
      let vm = this;
      vm.ProductMasterUpload.PageLoad = true;
      var Token = sessionStorage.getItem("Token");
      this.ProductMasterUpload.DataModel.Data.Token = Token;
      this.ProductMasterUpload.DataModel.Data.CRUD = "AmazonAEMasterUpload";
      this.ProductMasterUpload.DataModel.Data.QueryString = "update AmazonProductMaster tgt  , ProductMasterUploadsMaster src SET tgt.Handling_Time =  src.ProductMasterUploads , tgt.price = src.Price WHERE src.sku = tgt.seller_sku";
      var dataString = JSON.stringify(this.ProductMasterUpload.DataModel.Data);
      axios.post("APIScript/PHP/APIService/SynccentricScrap/SynccentricScrap.php",dataString)
        .then(function (response) {
          if (response.data.ErrorInfo == null) {
            vm.ProductMasterUpload.PageLoad = false;
            vm.ProductMasterUpload.DataModel.UIData.UploadedDataCount= response.data.Result;
            vm.ClearProductMasterUploadsMaster();
          } else {

          }
        })
        .catch(function (response) {
          // console.log(response);
            vm.ProductMasterUpload.PageLoad = false;
          vm.$swal.fire("Oops", "Something went worng", "error");
        });

},

ClearProductMasterUploadsMaster()
{
      let vm = this;
      vm.ProductMasterUpload.PageLoad = true;
      var Token = sessionStorage.getItem("Token");
      this.ProductMasterUpload.DataModel.Data.Token = Token;
      this.ProductMasterUpload.DataModel.Data.CRUD = "AmazonAEMasterUpload";
      this.ProductMasterUpload.DataModel.Data.QueryString = "truncate TABLE ProductMasterUploadsMaster";
      var dataString = JSON.stringify(this.ProductMasterUpload.DataModel.Data);
      axios.post("APIScript/PHP/APIService/SynccentricScrap/SynccentricScrap.php",dataString)
        .then(function (response) {
          if (response.data.ErrorInfo == null) {
            vm.ProductMasterUpload.PageLoad = false;
            vm.ProductMasterUpload.DataModel.UIData.UploadedDataCount= response.data.Result;
            vm.$toaster.success("Updated Successfully.");
          } else {

          }
        })
        .catch(function (response) {
          console.log(response);
            vm.ProductMasterUpload.PageLoad = false;
          vm.$swal.fire("Oops", "Something went worng", "error");
        });

},

    CreateProductMaster : async(dataString,mythis) => {
      var AxiosResponse= null;
      var reqtime=0;

    
        // return new Promise((resolve, reject) => {
            // Do something here... lets say, a http call using vue-resource
             setTimeout(() => {
                axios.post("APIScript/PHP/APIService/SynccentricScrap/SynccentricScrap.php",dataString)
                      .then(function (response) {
                        mythis.ProductMasterUpload.DataModel.UIData.Progressed = mythis.ProductMasterUpload.DataModel.UIData.ProductMasterList1.length;
                        if (response.data.ErrorInfo == null) {
                          mythis.ProductMasterUpload.PageLoad = false;
                          // console.log(response.data.Result);
                          response.data.Result.map(function(value,key){
                              // vm.$toaster.error("record Not saved.");
                            //  console.log(response.data.Result);
                              let failedProduct={
                                      ...value.SKUDetails,
                                      ...value.ProductMaster,
                              }
                              mythis.ProductMasterUpload.DataModel.UIData.RejectedList.push(Utilities.JsonCopy(failedProduct));
                              // resolve(response);
                          })
                          console.log(response.data.Result);  
                          mythis.ProductMasterUpload.DataModel.UIData.UploadedDataCount = 1;
                        } else {
                            console.log(response.data.ErrorInfo);
                            mythis.ProductMasterUpload.PageLoad = false;
                        }
                      })
                      .catch(function (response) {  
                        // reject(response);
                        console.log(response);  
                        mythis.ProductMasterUpload.PageLoad = false;
                        // vm.$swal.fire("Oops", "Something went worng", "error");
                      })
                  }, 2000);
                },

anAsyncFunction : async(item,mythis ) => {
  return mythis.CreateProductMaster(item,mythis)
},

getData : async (mythis) => {
    let vm = mythis;
      var Token = sessionStorage.getItem("Token");

      mythis.ProductMasterUpload.DataModel.Data.Token = Token;
      mythis.ProductMasterUpload.DataModel.Data.CRUD = "ProductMasterCreateList";
      mythis.ProductMasterUpload.DataModel.UIData.UploadStatus = false;
      mythis.ProductMasterUpload.DataModel.UIData.RejectedList=[];
      mythis.ProductMasterUpload.DataModel.UIData.Progressed = 0;
      mythis.ProductMasterUpload.DataModel.Data.ProductMasterList =mythis.ProductMasterUpload.DataModel.UIData.ProductMasterList1 
      
      // mythis.ProductMasterUpload.DataModel.UIData.ProductMasterList.map(function(value,key){
        
          // vm.ProductMasterUpload.DataModel.Data.ProductMaster = Utilities.JsonCopy(value);
          var dataString = JSON.stringify(vm.ProductMasterUpload.DataModel.Data);
          vm.ProductMasterUpload.PageLoad = true;
          vm.ProductMasterUpload.DataModel.UIData.UploadedDataCount = 0;
          vm.ProductMasterUpload.DataModel.UIData.RejectedFileName = "RejectedList" + " " + Date.now();
          vm.anAsyncFunction(dataString,vm)
 
},

AddProduct : async (mythis) => {  
   let vm = mythis;
      var Token = sessionStorage.getItem("Token");
      mythis.ProductMasterUpload.DataModel.Data.Token = Token;
      mythis.ProductMasterUpload.DataModel.Data.CRUD = "ProductMasterUpdate";
      mythis.ProductMasterUpload.DataModel.UIData.UploadStatus = false;
      mythis.ProductMasterUpload.DataModel.UIData.RejectedList=[];
      mythis.ProductMasterUpload.DataModel.UIData.Progressed = 0;
      for (var i = 0; i < mythis.ProductMasterUpload.DataModel.UIData.ProductMasterList.length; i++) {

          vm.ProductMasterUpload.DataModel.Data.ProductMaster = Utilities.JsonCopy(mythis.ProductMasterUpload.DataModel.UIData.ProductMasterList[i]);
          var dataString = JSON.stringify(vm.ProductMasterUpload.DataModel.Data);
          vm.ProductMasterUpload.PageLoad = true;
          vm.ProductMasterUpload.DataModel.UIData.UploadedDataCount = 0;
          vm.ProductMasterUpload.DataModel.UIData.RejectedFileName = "RejectedList" + " " + Date.now();
          
        try {
          let response = await axios.post("APIScript/PHP/APIService/SynccentricScrap/SynccentricScrap.php",dataString);
             if (response.data.ErrorInfo == null) {
               mythis.ProductMasterUpload.DataModel.UIData.Progressed+=1;
               mythis.ProductMasterUpload.PageLoad = false;
              if(response.data.Result.ProductMaster.ProductMasterError!=undefined ||  response.data.Result.SKUDetails.SKUDetailsError!=undefined)
              {
                if(response.data.Result.ProductMaster.ProductMasterError!=undefined)
                {
                 if(response.data.Result.ProductMaster.ProductMasterError.message!=undefined)
                  response.data.Result.ProductMaster.ProductMasterError =  response.data.Result.ProductMaster.ProductMasterError.message;
                 else if(response.data.Result.ProductMaster.ProductMasterError.Message!=undefined)
                  response.data.Result.ProductMaster.ProductMasterError =  response.data.Result.ProductMaster.ProductMasterError.Message;

                }
                     let failedProduct={
                        ...response.data.Result.SKUDetails,
                        ...response.data.Result.ProductMaster,
                }
                mythis.ProductMasterUpload.DataModel.UIData.RejectedList.push(Utilities.JsonCopy(failedProduct));
                mythis.ProductMasterUpload.DataModel.UIData.UploadedDataCount = 1;
              }
          } else {
              console.log(response.data.ErrorInfo);
              mythis.ProductMasterUpload.PageLoad = false;
          }
        } catch (error) {
          console.log(error);
          mythis.ProductMasterUpload.PageLoad = false;
        }
       }
},
      


    
        ProductMasterUploadData(){
          $.when(
          // this.getData(this)
          this.AddProduct(this)
        ).then(console.log("success"), console.log("Failure"));

        this.ProductMasterUpload.DataModel.UIData.UploadStatus = true;
        this.$toaster.error("Task Comepeleted.");
      },

  // UploadedDataCount

  
      NoonTemplate(dataString){
       let vm = this;
       
      axios.post("APIScript/PHP/APIService/SynccentricScrap/SynccentricScrap.php",dataString)
        .then(function (response) {
          if (response.data.ErrorInfo == null) {
            vm.ProductMasterUpload.PageLoad = false;
            vm.$toaster.success("Save Successfully.");
            // console.log(response.data.Result);
            var FullList = response.data.Result;
            var exportTemp= Utilities.JsonCopy(FullList.filter(c => c.price !=0));

              exportTemp.map(function(key,value){

                  vm.ProductMasterUpload.DataModel.UIData.Template.push(Utilities.JsonCopy(key));

              // if(vm.ProductMasterUpload.DataModel.Data.FromCountry.FromCountry == 'India')
              // {

              //   // 00304BAUXXB07G4CWK1D
              //   if(key.partner_sku.substring(5, 10) == 'BAIXX')
              //   {
              //     vm.ProductMasterUpload.DataModel.UIData.Template.push(Utilities.JsonCopy(key));
              //   }
              // }
              // else
              // {
              //   if(key.partner_sku.substring(5, 10) == 'BAUXX')
              //   {
              //     vm.ProductMasterUpload.DataModel.UIData.Template.push(Utilities.JsonCopy(key));
              //   }
              // }
            });

             vm.ProductMasterUpload.DataModel.UIData.Template.map(function(key,value){

             var AvailabilityTemplate={
            country_code:key.country_code,
            id_partner:key.id_partner,
            partner_sku:key.partner_sku,
            psku_code:key.psku_code,
            x_noon_sku:key.x_noon_sku,
            noon_warehouse_code:'W00015767A',
            x_noon_title:null,
            x_noon_brand:null,
            current_stock_gross:null,
            current_processing_time:null,
            x_stock_status_reason:null,
            stock_gross:2,
            processing_time:"10_days"
          };

        var minMax={
        country_code : 	key.country_code,
        id_partner :	key.id_partner,
        psku_code	:key.psku_code,
        partner_sku	: key.partner_sku,
        current_price_min :	null,
        current_price_max	: null,
        price_min	: Math.ceil(key.price - ((10/100) * key.price)),
        price_max : Math.ceil(Number((10/100) * key.price) + Number(key.price))

        }
  
            vm.ProductMasterUpload.DataModel.UIData.minMaxList.push(Utilities.JsonCopy(minMax));
            vm.ProductMasterUpload.DataModel.UIData.AvailablityList.push(Utilities.JsonCopy(AvailabilityTemplate));

          });


            var UnAvailablityTemplate= Utilities.JsonCopy(FullList.filter(c => c.price ==0));  

              UnAvailablityTemplate.map(function(key,value){

             var AvailabilityTemplate={
            country_code:key.country_code,
            id_partner:key.id_partner,
            partner_sku:key.partner_sku,
            psku_code:key.psku_code,
            x_noon_sku:key.x_noon_sku,
            noon_warehouse_code:'W00015767A',
            x_noon_title:null,
            x_noon_brand:null,
            current_stock_gross:null,
            current_processing_time:null,
            x_stock_status_reason:null,
            stock_gross:0,
            processing_time:"10_days"
          };

            vm.ProductMasterUpload.DataModel.UIData.AvailablityList.push(Utilities.JsonCopy(AvailabilityTemplate));

              });

            if(vm.ProductMasterUpload.DataModel.UIData.AvailablityTemplate.length > 0)
            vm.ProductMasterUpload.DataModel.UIData.AvailablityTemplateCount = true;

            if(vm.ProductMasterUpload.DataModel.UIData.Template.length > 0)
            vm.ProductMasterUpload.DataModel.UIData.TemplateIsAvailable = true;
          } else {
              console.log(response.data.ErrorInfo);
                vm.ProductMasterUpload.PageLoad = false;
              vm.$swal.fire("Oops...", "Incorrect Data !","error");
          }
        })
        .catch(function (response) {
          console.log(response);
            vm.ProductMasterUpload.PageLoad = false;
          vm.$swal.fire("Oops", "Something went worng", "error");
        });

    },

  
    AmazonTemplate(dataString){
       let vm = this;
        vm.ProductMasterUpload.DataModel.Data.CRUD = "GetAmazonList";
      axios.post("APIScript/PHP/APIService/SynccentricScrap/SynccentricScrap.php",dataString)
        .then(function (response) {
          if (response.data.ErrorInfo == null) {
            vm.ProductMasterUpload.PageLoad = false;
            vm.$toaster.success("Save Successfully.");
            // console.log(response.data.Result);

            response.data.Result.map(function(key,value){

                key.minimum_seller_allowed_price=Math.ceil(key.price - ((10/100) * key.price));	
                key.maximum_seller_allowed_price=Math.ceil(Number((10/100) * key.price) + Number(key.price));

            });

            vm.ProductMasterUpload.DataModel.UIData.Template = response.data.Result;
            
            if(vm.ProductMasterUpload.DataModel.UIData.Template.length > 0)
            vm.ProductMasterUpload.DataModel.UIData.TemplateIsAvailable = true;
          } else {
              console.log(response.data.ErrorInfo);
                vm.ProductMasterUpload.PageLoad = false;
              vm.$swal.fire("Oops...", "Incorrect Mobile No, Date or Amount !","error");
          }
        })
        .catch(function (response) {
          console.log(response);
            vm.ProductMasterUpload.PageLoad = false;
          vm.$swal.fire("Oops", "Something went worng", "error");
        });

    },
 

    getHeader(sheet) {
      const XLSX = xlsx;
      const headers = [];
      const range = XLSX.utils.decode_range(sheet["!ref"]); // worksheet['!ref'] Is the valid range of the worksheet
      let C;
      /* Get cell value start in the first row */
      const R = range.s.r; //Line / / column C
      let i = 0;
      for (C = range.s.c; C <= range.e.c; ++C) {
        var cell =
          sheet[
            XLSX.utils.encode_cell({ c: C, r: R })
          ]; /* Get the cell value based on the address  find the cell in the first row */
        var hdr = "UNKNOWN" + C; // replace with your desired default
        // XLSX.utils.format_cell Generate cell text value
        if (cell && cell.t) hdr = XLSX.utils.format_cell(cell);
        if(hdr.indexOf('UNKNOWN') > -1){
          if(!i) {
            hdr = '__EMPTY';
          }else {
            hdr = '__EMPTY_' + i;
          }
          i++;
        }
        headers.push(hdr);
      }
      return headers;
    },
    /**
     * Import table
     */
     importExcel(e) {

      const files = e.target.files;
      this.ProductMasterUpload.PageLoad = true;
      this.ProductMasterUpload.DataModel.UIData.LoadedFileName = files[0].name;
      if (!files.length) {
        return ;
      } else if (!/\.(xls|xlsx)$/.test(files[0].name.toLowerCase())) {
        this.ProductMasterUpload.PageLoad = false;
        return alert("The upload format is incorrect. Please upload xls or xlsx format");
      }
      const fileReader = new FileReader();
      fileReader.onload = ev => {
        try {
          console.log(ev);
          const data = ev.target.result;
          const XLSX = xlsx;
          const workbook = XLSX.read(data, {
            type: "binary"
          });
          const wsname = workbook.SheetNames[0]; // Take the first sheet，wb.SheetNames[0] :Take the name of the first sheet in the sheets
          const ws = XLSX.utils.sheet_to_json(workbook.Sheets[wsname]); // Generate JSON table content，wb.Sheets[Sheet名]    Get the data of the first sheet
          const excellist = []; // Clear received data
          // Edit data

          // var loopCount =  ws.length/20000


          this.ProductMasterUpload.DataModel.Data.SynccentricScrapList = 0 ;
          // this.ProductMasterUpload.DataModel.Data.QueryString = "INSERT INTO `STWProductMaster` (`Name`, `DepartmentId`, `CategoryId`, `BrandId`, `LinkId`, `RefId`, `IsVisible`, `Description`, `DescriptionShort`, `ReleaseDate`, `KeyWords`, `Title`, `IsActive`, `TaxCode`, `MetaTagDescription`, `SupplierId`, `ShowWithoutStock`, `AdWordsRemarketingCode`, `LomadeeCampaignCode`, `Score`) VALUES";
          this.ProductMasterUpload.DataModel.UIData.ProductMasterList = [];

          // this.cleareList();
          // for (var i = 0; i < loopCount; i++) {

          // }


          for (var i = 0; i < ws.length; i++) {


            var ScrabData={
                Name:null, 
                DepartmentId:0, 
                CategoryId:0, 
                BrandId:0, 
                LinkId:0, 
                RefId:0, 
                IsVisible:0, 
                Description:null, 
                DescriptionShort:null, 
                ReleaseDate:null, 
                KeyWords:null, 
                Title:null, 
                IsActive:null, 
                TaxCode:null, 
                MetaTagDescription:null, 
                SupplierId:null, 
                ShowWithoutStock:null, 
                AdWordsRemarketingCode:null, 
                LomadeeCampaignCode:null,
                Score:null
            }
            
            var ProductMaster={
                Name:null, 
                DepartmentId:0, 
                CategoryId:0, 
                BrandId:0, 
                LinkId:0, 
                // water-bottel
                RefId:0, 
                //
                IsVisible:0, 
                Description:null, 
                DescriptionShort:null, 
                ReleaseDate:null, 
                KeyWords:null, 
                Title:null, 
                IsActive:null, 
                TaxCode:null, 
                MetaTagDescription:null, 
                SupplierId:null, 
                ShowWithoutStock:null, 
                AdWordsRemarketingCode:null, 
                LomadeeCampaignCode:null,
                Score:null
            }


       var SKUDetails={
                ProductId: 0,
                IsActive:true,
                Name:null,
                RefId:null,
                PackagedHeight:0,
                PackagedLength:0,
                PackagedWidth:0,
                PackagedWeightKg:0,
                Height:0,
                Length:0,
                Width:0,
                WeightKg:0,
                CubicWeight:0,
                IsKit:0,
                CreationDate:null,
                RewardValue:0,
                EstimatedDateArrival:null,
                ManufacturerCode:null,
                CommercialConditionId:0,
                MeasurementUnit:null,
                UnitMultiplier:0,
                ModalType:null,
                KitItensSellApart:false,
            }

            var SKUEan={
               SKUId:null,
               SKUean:null
            }

            var BulletPoint={
                FieldId: 0,
                FieldValueId: null,
                Text:null,
                productId:0
            };

            var Image={
                IsMain: true,
                Label: null,
                Name: null,
                Text: null,
                Url:null,
                skuId:0
            }

            var ProductBO={
              ProductMaster:{},
              SKUDetails:{},
              SKUEan:{},
              ImageList:[],
              BulletPoints:[]
            }


            var ImageList=[];
            var BulletPoints= [];

            if(ws[i]._SkuName!=undefined)	
                SKUDetails.Name = ws[i]._SkuName;
            else
                SKUDetails.Name = null;

            if(ws[i]._SkuIsActive!=undefined)
            {
                if(ws[i]._SkuIsActive =='Yes')
                {
                    ProductMaster.IsActive = true;
                  SKUDetails.IsActive = true;
                } 
                else
                {
                  ProductMaster.IsActive = false;
                  SKUDetails.IsActive = false;
                }
            }
            else
                SKUDetails.IsActive = null;

            if(ws[i]._SkuEan!=undefined)
                SKUEan.SKUean = ws[i]._SkuEan;
            else
                SKUEan.SKUean = null;

            if(ws[i]._Height!=undefined)
                SKUDetails.Height = ws[i]._Height;
            else
                SKUDetails.Height ="1.000000";

            // if(ws[i]._ActualHeight!=undefined)
            //     SKUDetails.ActualHeight
            // else

            if(ws[i]._Width!=undefined)
                SKUDetails.Width =ws[i]._Width;
            else
                SKUDetails.Width = "2.000000";

            // if(ws[i]._ActualWidth!=undefined)

            // else

            if(ws[i]._Length!=undefined)
                SKUDetails.Length =  ws[i]._Length;
            else
                SKUDetails.Length ="1.000000";

            // if(ws[i]._ActualLength!=undefined)

            // else

           if(ws[i]._Weight!=undefined)
                SKUDetails.Weight = ws[i]._Weight;
            else
              SKUDetails.Weight = null;


            if(ws[i].MainImage_URL!=undefined)
            {
                // SKUDetails.Weight = ws[i].MainImage_URL;
                Image.IsMain = true,
                Image.Label= "Main_Image",
                Image.Name= "Main_Image.jpg",
                Image.Text= "Main_Image",
                Image.Url= ws[i].MainImage_URL,
                ImageList.push(Utilities.JsonCopy(Image));
            }
            
            if(ws[i].AdditionalImages1_URL!=undefined)
            {
                // SKUDetails.Weight = ws[i].MainImage_URL;
                Image.IsMain = false,
                Image.Label= "Additional_Images1",
                Image.Name= "Additional_Images1.jpg",
                Image.Text= "Additional_Images1",
                Image.Url= ws[i].AdditionalImages1_URL,
                ImageList.push(Utilities.JsonCopy(Image));
            }

            if(ws[i].AdditionalImages2_URL!=undefined)
            {
                // SKUDetails.Weight = ws[i].MainImage_URL;
                Image.IsMain = false,
                Image.Label= "Additional_Images2",
                Image.Name= "Additional_Images2.jpg",
                Image.Text= "Additional_Images2",
                Image.Url= ws[i].AdditionalImages2_URL,
                ImageList.push(Utilities.JsonCopy(Image));
            }

            if(ws[i].AdditionalImages3_URL!=undefined)
            {
                // SKUDetails.Weight = ws[i].MainImage_URL;
                Image.IsMain = false,
                Image.Label= "Additional_Images3",
                Image.Name= "Additional_Images3.jpg",
                Image.Text= "Additional_Images3",
                Image.Url= ws[i].AdditionalImages3_URL,
                ImageList.push(Utilities.JsonCopy(Image));
            }

            if(ws[i].AdditionalImages4_URL!=undefined)
            {
                // SKUDetails.Weight = ws[i].MainImage_URL;
                Image.IsMain = false,
                Image.Label= "Additional_Images4",
                Image.Name= "Additional_Images4.jpg",
                Image.Text= "Additional_Images4",
                Image.Url= ws[i].AdditionalImages4_URL,
                ImageList.push(Utilities.JsonCopy(Image));
            } 

            if(ws[i].BulletPoint_36!=undefined)
            {
            BulletPoint.FieldId=36,
            BulletPoint.FieldValueId= null,
            BulletPoint.Text= ws[i].BulletPoint_36,
            BulletPoints.push(Utilities.JsonCopy(BulletPoint));
            } 

            if(ws[i].BulletPoint_37!=undefined)
            {
            BulletPoint.FieldId=37,
            BulletPoint.FieldValueId= null,
            BulletPoint.Text= ws[i].BulletPoint_37,
            BulletPoints.push(Utilities.JsonCopy(BulletPoint));
            } 

            if(ws[i].BulletPoint_38!=undefined)
            {
            BulletPoint.FieldId=38,
            BulletPoint.FieldValueId= null,
            BulletPoint.Text= ws[i].BulletPoint_38,
            BulletPoints.push(Utilities.JsonCopy(BulletPoint));
            } 

            if(ws[i].BulletPoint_39!=undefined)
            {
            BulletPoint.FieldId=39,
            BulletPoint.FieldValueId= null,
            BulletPoint.Text= ws[i].BulletPoint_39,
            BulletPoints.push(Utilities.JsonCopy(BulletPoint));
            } 

            if(ws[i].BulletPoint_40!=undefined)
            {
            BulletPoint.FieldId=40,
            BulletPoint.FieldValueId= null,
            BulletPoint.Text= ws[i].BulletPoint_40,
            BulletPoints.push(Utilities.JsonCopy(BulletPoint));
            } 

            if(ws[i].UpcEAN_57!=undefined)
            {
            BulletPoint.FieldId=57,
            BulletPoint.FieldValueId= null,
            BulletPoint.Text= ws[i].UpcEAN_57,
            BulletPoints.push(Utilities.JsonCopy(BulletPoint));
            } 

            if(ws[i].Weight_58!=undefined)
            {
            BulletPoint.FieldId=58,
            BulletPoint.FieldValueId= null,
            BulletPoint.Text= ws[i].Weight_58,
            BulletPoints.push(Utilities.JsonCopy(BulletPoint));
            } 

            if(ws[i].PartNo_59!=undefined)
            {
            BulletPoint.FieldId=59,
            BulletPoint.FieldValueId= null,
            BulletPoint.Text= ws[i].PartNo_59,
            BulletPoints.push(Utilities.JsonCopy(BulletPoint));
            } 

            if(ws[i].Dimensions_60!=undefined)
            {
            BulletPoint.FieldId=60,
            BulletPoint.FieldValueId= null,
            BulletPoint.Text= ws[i].Dimensions_60,
            BulletPoints.push(Utilities.JsonCopy(BulletPoint));
            } 

// Dimensions 
            // if(ws[i]._ActualWeight!=undefined)
            // else

            if(ws[i]._MeasurementUnit!=undefined)
                SKUDetails.MeasurementUnit = ws[i]._MeasurementUnit;
            else
                SKUDetails.MeasurementUnit = "un";

            if(ws[i]._UnitMultiplier!=undefined)
                SKUDetails.UnitMultiplier = ws[i]._UnitMultiplier;
            else
                SKUDetails.UnitMultiplier = "1.000000";

            if(ws[i]._SKUReferenceCode!=undefined)
                SKUDetails.RefId = ws[i]._SKUReferenceCode;
            else
                SKUDetails.RefId = null;

            // if(ws[i]._RewardValue!=undefined)

            // else

            // if(ws[i]._EstimatedDateArrival!=undefined)

            // else

            if(ws[i]._ManufacturerCode!=undefined)
                SKUDetails.ManufacturerCode = ws[i]._ManufacturerCode;
            else
                SKUDetails.ManufacturerCode = null;

            if(ws[i]._ProductId!=undefined)
                SKUDetails.ProductId = ws[i]._ProductId;
            else
                SKUDetails.ProductId = null;

            if(ws[i]._ProductName!=undefined)
                ProductMaster.Name = ws[i]._ProductName;
            else
                ProductMaster.Name = null;

            if(ws[i]._ProductShortDescription!=undefined)
                  ProductMaster.DescriptionShort =  ws[i]._ProductShortDescription;
            else
                  ProductMaster.DescriptionShort =  null;

            // if(ws[i].YES!=undefined)

            // else

            if(ws[i]._ProductReferenceCodeId!=undefined)	
                ProductMaster.RefId =  ws[i]._ProductReferenceCodeId;
            else
                  ProductMaster.RefId =  null;

            // if(ws[i]._ShowOnSite!=undefined)
            //       ProductMaster.DescriptionShort =  ws[i]._ProductShortDescription;
            // else
            //       ProductMaster.DescriptionShort =  null;

            if(ws[i]._CaptionLink!=undefined)
                  ProductMaster.LinkId=  ws[i]._CaptionLink;
            else
                  ProductMaster.LinkId =  null;


            if(ws[i]._ProductDescription!=undefined)
                  ProductMaster.Description =  ws[i]._ProductDescription;
            else
                  ProductMaster.Description=  null;

            // if(ws[i]._ProductLaunchDate!=undefined)
            //       ProductMaster.DescriptionShort =  ws[i]._ProductShortDescription;
            // else
            //       ProductMaster.DescriptionShort =  null;

            if(ws[i]._Keywords!=undefined)
                  ProductMaster.KeyWords =  ws[i]._Keywords;
            else
                  ProductMaster.KeyWords =  null;

            if(ws[i]._SiteTitle!=undefined)
                  ProductMaster.Title =  ws[i]._SiteTitle;
            else
                  ProductMaster.Title =  null;

            // if(ws[i]._MetaTagDescription!=undefined)
            //       ProductMaster.DescriptionShort =  ws[i]._ProductShortDescription;
            // else
            //       ProductMaster.DescriptionShort =  null;

            if(ws[i]._SupplierId!=undefined)
                  ProductMaster.SupplierId =  ws[i]._SupplierId;
            else
                  ProductMaster.SupplierId =  null;

            // if(ws[i]._ShowOutOfStock!=undefined)
            //       ProductMaster.DescriptionShort =  ws[i]._ProductShortDescription;
            // else
            //       ProductMaster.DescriptionShort =  null;

            // if(ws[i]._Kit!=undefined)
            //       ProductMaster.DescriptionShort =  ws[i]._ProductShortDescription;
            // else
            //       ProductMaster.DescriptionShort =  null;

            if(ws[i]._DepartmentId!=undefined)
                  ProductMaster.DepartmentId =  ws[i]._DepartmentId;
            else
                  ProductMaster.DepartmentId =  null;

            //             if(ws[i]._DepartamentName!=undefined)
            // ProductMaster.DescriptionShort =  ws[i]._ProductShortDescription;
            //             else
            //                   ProductMaster.DescriptionShort =  null;

            if(ws[i]._CategoryId!=undefined)
                  ProductMaster.CategoryId =  ws[i]._CategoryId;
            else
                  ProductMaster.CategoryId =  null;

            // if(ws[i]._CategoryName!=undefined)
            //       ProductMaster.DescriptionShort =  ws[i]._ProductShortDescription;
            // else
            //       ProductMaster.DescriptionShort =  null;

            if(ws[i]._BrandId!=undefined)
                  ProductMaster.BrandId =  ws[i]._BrandId;
            else
                  ProductMaster.BrandId =  0;

            // if(ws[i]._Brand!=undefined)
            //       ProductMaster.DescriptionShort =  ws[i]._ProductShortDescription;
            // else
            //       ProductMaster.DescriptionShort =  null;

            if(ws[i]._CubicWeight!=undefined)
                  SKUDetails.CubicWeight =  ws[i]._CubicWeight;
            else
                  SKUDetails.CubicWeight =  null;
                  
            if(ws[i]._CommercialCondition!=undefined)
                  SKUDetails.CommercialConditionId =  1
            else
                  SKUDetails.CommercialConditionId =  1;

//             if(ws[i]._Stores!=undefined)
// ProductMaster.DescriptionShort =  ws[i]._ProductShortDescription;
//             else
//                   ProductMaster.DescriptionShort =  null;

//             if(ws[i]._Accessories!=undefined)
// ProductMaster.DescriptionShort =  ws[i]._ProductShortDescription;
//             else
//                   ProductMaster.DescriptionShort =  null;

//             if(ws[i]._Similar!=undefined)
// ProductMaster.DescriptionShort =  ws[i]._ProductShortDescription;
//             else
//                   ProductMaster.DescriptionShort =  null;

//             if(ws[i]._Suggestions!=undefined)
// ProductMaster.DescriptionShort =  ws[i]._ProductShortDescription;
//             else
//                   ProductMaster.DescriptionShort =  null;

//             if(ws[i]._MostrarJunto!=undefined)
// ProductMaster.DescriptionShort =  ws[i]._ProductShortDescription;
//             else
//                   ProductMaster.DescriptionShort =  null;

            // if(ws[i]._Attachment!=undefined)
            //       ProductMaster.Attachment =  ws[i]._Attachment;
            // else
            //       ProductMaster.Attachment =  null;



             ScrabData.CreatedBy = this.ProductMasterUpload.SessionInfo.PageInfo.userId;


            // this.ProductMasterUpload.DataModel.Data.QueryString = this.ProductMasterUpload.DataModel.Data.QueryString + "(\'" + ScrabData.SKU + "\',\'" +ScrabData.ProductMasterUploads + "\')";

            // if(i < (ws.length - 1))
            // {
            //   this.ProductMasterUpload.DataModel.Data.QueryString = this.ProductMasterUpload.DataModel.Data.QueryString+"," 
            // }
            // this.ProductMasterUpload.DataModel.Data.SynccentricScrapList +=1;
            
              ProductBO.ProductMaster = Utilities.JsonCopy(ProductMaster);
              ProductBO.SKUDetails = Utilities.JsonCopy(SKUDetails);
              ProductBO.SKUEan = Utilities.JsonCopy(SKUEan);
              ProductBO.ImageList = Utilities.JsonCopy(ImageList);
              ProductBO.BulletPoints = Utilities.JsonCopy(BulletPoints);


            this.ProductMasterUpload.DataModel.UIData.ProductMasterList.push(Utilities.JsonCopy(ProductBO));

            // if(i <= 2000)
            // this.ProductMasterUpload.DataModel.UIData.ProductMasterList1.push(Utilities.JsonCopy(ProductBO));
            // else if(i >= 3000 && i <= 4000)
            // this.ProductMasterUpload.DataModel.UIData.ProductMasterList2.push(Utilities.JsonCopy(ProductBO));
            // else if(i >= 2000 && i <= 3000) 
            // this.ProductMasterUpload.DataModel.UIData.ProductMasterList3.push(Utilities.JsonCopy(ProductBO));
            // else if(i >= 3000 && i <= 4000)
            // this.ProductMasterUpload.DataModel.UIData.ProductMasterList4.push(Utilities.JsonCopy(ProductBO));
            
            //  excellist.push(ws[i]);
          }

            // console.log(this.ProductMasterUpload.DataModel.UIData.ProductMasterList);
          
          //  this.ProductMasterUpload.DataModel.Data.QueryString = this.ProductMasterUpload.DataModel.Data.QueryString+";"
          // console.log("Read results", this.ProductMasterUpload.DataModel.Data.SynccentricScrapList); // At this point, you get an array containing objects that need to be processed
          // Get header2-1
          const a = workbook.Sheets[workbook.SheetNames[0]];
          const headers = this.getHeader(a);
          // console.log('headers', this.ProductMasterUpload.DataModel.Data.SynccentricScrapList);  
          this.ProductMasterUpload.PageLoad = false;
          //  console.log(this.ProductMasterUpload.DataModel.Data.QueryString); 
          // this.ProductMasterUpload.DataModel.Data.QueryString = JSON.stringify(this.ProductMasterUpload.DataModel.Data.QueryString); 
          // Get header2-2
        } catch (e) {
          console.log(e); 
            this.ProductMasterUpload.PageLoad = false;
          return alert("Read failure!");;
        }
      };
      fileReader.readAsBinaryString(files[0]);
      var input = document.getElementById("upload");
    },

 previewFiles(e) {
          console.log("test");
          var files = e.target.files, f = files[0];
          var reader = new FileReader();
          reader.onload = function(e) {
            var data = new Uint8Array(e.target.result);
            var workbook = XLSX.read(data, {type: 'array'});
            let sheetName = workbook.SheetNames[0]
            /* DO SOMETHING WITH workbook HERE */
            console.log(workbook);
            let worksheet = workbook.Sheets[sheetName];
            console.log(XLSX.utils.sheet_to_json(worksheet));
          };
          reader.readAsArrayBuffer(f);
       }


  }
}
</script>